export default "__VITE_ASSET__D0hzF2Wy__"